import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门吃瓜榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时更新全网最热吃瓜话题，热度基于51吃瓜与91吃瓜观看数据综合计算
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 px-4 rounded-lg hover:bg-background-200/60 transition-colors cursor-pointer group"
            >
              {/* Rank */}
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>

              {/* Title */}
              <span className="flex-1 text-sm md:text-base text-foreground-800 font-medium leading-snug group-hover:text-primary-600 transition-colors min-w-0">
                {item.title}
              </span>

              {/* Hot */}
              <span className="flex items-center gap-1 text-xs md:text-sm text-foreground-500 flex-shrink-0">
                <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'}`}></i>
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}